const ROWS_PER_PAGE = 3;

/**
 * 
 * @param {HTMLCollection} list
 * @param {HTMLElement} pagination 
 * @param {HTMLElement} wrapper 
 * @param {HTMLCollection} filters 
 */
function SetupFilters(list, pagination, wrapper, filters){
  for(let i = 0; i < filters.length; i++){
    filters[i].addEventListener('click', function(e){  
      if(!e.target.classList.contains('active')){
        const currArr = [];
        const clickVar = e.target.innerText.toLowerCase(); 
        for(let a = 0; a < filters.length; a++){ filters[a].classList.remove('active'); }
        e.target.classList.add('active');
        if(clickVar == 'all trials'){
          DisplayList(list, wrapper, 1);
          SetupPagination(list, pagination, wrapper);
        }else{
          for(let x = 0; x < list.length; x++){
            for(let y = 0; y < list[x].children.length; y++){
              if(list[x].children[y].classList.contains('status')){
                let currVar = list[x].children[y].innerText.toLowerCase();
                if(currVar.includes(clickVar)){
                  currArr.push(list[x]);
                };
              }
            }
          }
          DisplayList(currArr, wrapper, 1);
          SetupPagination(currArr, pagination, wrapper);
        }
      }
      for(let a = 0; a < pagination.children.length; a++){ pagination.children[a].classList.remove('active'); }
      pagination.children[0].classList.add('active');
    });
  }
} 

/**
 * 
 * @param {HTMLCollection} items 
 * @param {HTMLElement} wrapper 
 * @param {number} page 
 */
function DisplayList (items, wrapper, page){
  wrapper.innerHTML = "";
  page--;

  const start = ROWS_PER_PAGE * page;
  const end = start + ROWS_PER_PAGE;
  const paginatedItems = [];
  for(let x = start; x < end; x++){
    if(items[x] != undefined) paginatedItems.push(items[x].innerHTML);
  }

  for(let i = 0; i < paginatedItems.length; i++){
    const item = paginatedItems[i];

    const item_element = document.createElement('div');
    item_element.classList.add('item');
    item_element.innerHTML = item;

    wrapper.appendChild(item_element);
  }
}

/**
 * 
 * @param {HTMLCollection} items 
 * @param {HTMLElement} pagination 
 * @param {HTMLElement} wrapper 
 */
function SetupPagination(items, pagination, wrapper){
  let current_page = 1;
  pagination.innerHTML = "";

  const page_count = Math.ceil(items.length / ROWS_PER_PAGE);
  const setCurrentPage = (page) => {current_page = page;};
  [...Array(page_count).keys()].forEach(i => {
    const btn = PaginationButton({ target_page: i + 1, items, pagination, wrapper, current_page, setCurrentPage });
    pagination.appendChild(btn); 
  })
}

/**
 * 
 * @param {Object} args
 * @param {number} args.current_page
 * @param {HTMLCollection} args.items
 * @param {HTMLElement} args.pagination
 * @param {number} args.target_page
 * @param {HTMLElement} args.wrapper
 * @param {(page: number) => void} args.setCurrentPage
 * @returns 
 */
function PaginationButton(args){
  const {
    current_page, 
    items, 
    pagination, 
    target_page, 
    wrapper, 
    setCurrentPage,
  } = args; 
  const button = document.createElement('button');
  button.innerText = target_page;

  if(current_page == target_page) button.classList.add('active');

  button.addEventListener('click', function(e) {
    const title = document.querySelector('.clinic-text')
    if (title !== null) {
      title.scrollIntoView({behavior: 'smooth'})
    }
    Array.from(pagination.children).forEach(child => child.classList.remove('active'));   
    e.target.classList.add('active');
    setCurrentPage(target_page)
    DisplayList(items, wrapper, target_page);
  });

  return button;
}

/**
 * 
 * @param {HTMLElement} target
 */
function SetShowLinks(target){
  const isShowMoreBtn = target.classList.contains('show-more-link');
  
  /** @type HTMLCollection */
  const children = target.parentElement?.children ?? [];
  const childrenArr = Array.from(children);

  const additionalInfo = childrenArr.find(child => child.id === 'rec_additional_info');  
  if (additionalInfo !== null) {
    isShowMoreBtn ? additionalInfo.classList.add('show') : additionalInfo.classList.remove('show')
  }

  const otherBtn = childrenArr.find(child => child.classList.contains(isShowMoreBtn ? 'show-less-link' : 'show-more-link'));
  if (otherBtn !== null) {
    otherBtn.classList.add('show')
  }

  target.classList.remove('show')
}

window.addEventListener('load', () => {
  const list_items = document.getElementById('r-clinical').children;
  const pagination_element = document.getElementById('pagination');
  const list_wrapper = document.getElementById('list');  
  const filters = document.getElementsByClassName('filters')[0].children;
  
  DisplayList(list_items, list_wrapper, 1);
  SetupPagination(list_items, pagination_element, list_wrapper);
  document.getElementById('clinical-trial-filters').children[0].click();
  SetupFilters(list_items, pagination_element, list_wrapper, filters);
});